export const contragentTypesChoices = [
  { name: 'Юридическое лицо', id: 'legalEntity' },
  { name: 'Физическое лицо', id: 'individual' },
  { name: 'Самозанятый', id: 'selfEmployed' },
];
